import React from 'react';
import { useSelector } from 'react-redux';

import { getDictionary } from '@travel/i18n';
import { useStandardUrl } from '@travel/traveler-core/hooks';
import useDeviceType, { MOBILE_SCREEN } from '@travel/traveler-core/hooks/useDeviceType';

import Dialog from 'components/Dialog';

import { Translate } from 'core/translate';

import styles from './privacyPolicy.module.scss';

type Props = {
  isPrivacyPolicyOpen: boolean;
  onPrivacyPolicyClose: () => void;
  onClickPrimary: () => void;
};

function PrivacyPolicy({ isPrivacyPolicyOpen, onPrivacyPolicyClose, onClickPrimary }: Props) {
  const isSP = useDeviceType() === MOBILE_SCREEN;

  const dictionary = useSelector(getDictionary);
  const { privacyPolicy, termsOfUse } = useStandardUrl(dictionary);

  return (
    <Dialog
      title={isSP ? <Translate id="MAUI_Legacy.Privacy_Section.Title" /> : null}
      isOpen={isPrivacyPolicyOpen}
      onClose={onPrivacyPolicyClose}
      hasEnableBack={false}
      buttonLabelPrimary={<Translate id="MAUI_Legacy.Important_Info.Agree" />}
      buttonLabelSecondary={<Translate id="Traveler_Common.Common.Cancel" />}
      onClickPrimary={onClickPrimary}
      onClickSecondary={onPrivacyPolicyClose}
      className={styles.wrapper}
      hasAnimation={true}
      dialogWrapperClassName={styles.dialogWrapper}
    >
      {!isSP && (
        <h4 className={styles.title}>
          <Translate id="MAUI_Legacy.Privacy_Section.Title" />{' '}
        </h4>
      )}
      <div className={styles.content}>
        <Translate id="MAUI_Legacy.Privacy_Section.Para1" className={styles.para} />
        <Translate id="MAUI_Legacy.Privacy_Section.Para2" className={styles.para} />
        <Translate
          id="MAUI_Legacy.Privacy_Section.Para3"
          className={styles.para}
          data={{
            terms_and_conditions: (
              <a href={termsOfUse.url} rel="noopener noreferrer">
                <Translate id="MAUI_Legacy.Important_Info.Terms_Conditions" />
              </a>
            ),
            privacy_policy: (
              <a href={privacyPolicy.url} rel="noopener noreferrer">
                <Translate id="MAUI_Legacy.Important_Info.Privacy_Policy" />
              </a>
            ),
          }}
        />
      </div>
    </Dialog>
  );
}

export default PrivacyPolicy;
